/* tslint:disable */
/* eslint-disable */
/**
 * Pull Guardian PR Dispatch
 * Contract for the `prdispatch` module. Intake has two entry points — an HTTP endpoint (`POST /api/prdispatch`) and the `pull-guardian-pr-dispatch` Azure Service Bus queue. Both intakes converge on the same queue: the HTTP controller enqueues onto the queue and the JMS listener runs the existing dispatch pipeline. This spec is the single source of truth for the `PrDispatchRequest` envelope consumed by both intakes. 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * HTTP-intake request body. Does NOT include `payloadAuthor` — the server derives it from the authenticated principal\'s JWT (`mail` / `email` claim) and injects it when building the Service Bus envelope. See `PrDispatchServiceBusEnvelope` for the downstream SB contract. 
 */
export interface PrDispatchRequest {
    /**
     * Email of the project owner the dispatch is acting on behalf of (a.k.a. \"on behalf of\" email, distinct from the signed-in dispatcher). 
     */
    'authorEmail': string;
    /**
     * Clone URL of the target Azure DevOps repository. Host MUST match the configured AzDO allow-list; otherwise the message is dropped with `kind=\"invalid_repo_host\"`. 
     */
    'repoUrl': string;
    /**
     * Natural-language task delivered to the coding agent via file (never argv). The 150 000 character cap is conservative against the Azure Service Bus 256 KB message / 64 KB user-property envelope. Oversize payloads are dropped with `kind=\"prompt_too_large\"`. 
     */
    'prompt': string;
    /**
     * Branch the PR targets (e.g. `main`, `release/2026.05`). Cloned shallowly with `--depth=1 --single-branch`. Non-blank. 
     */
    'targetBranch': string;
    /**
     * Optional work branch suffix. When provided, the work branch is `prdispatch/<value>`. When omitted, an AI-generated human-readable name is derived from `prompt` with a short hash suffix for collision avoidance. Payloads that fail the pattern are dropped with `kind=\"invalid_branch_name\"`. 
     */
    'newFeatureBranchName'?: string;
}
/**
 * Envelope consumed by the `pull-guardian-pr-dispatch` JMS queue. Produced server-side from `PrDispatchRequest` plus the signed-in principal\'s JWT. Every constraint is enforced at the listener boundary; non-conforming payloads are dropped with a labelled failure-kind counter increment. 
 */
export interface PrDispatchServiceBusEnvelope {
    'authorEmail': string;
    'repoUrl': string;
    'prompt': string;
    /**
     * Email of the human dispatcher — the signed-in principal that submitted the HTTP request. Injected by the controller from the JWT (`mail` / `email` claim); never accepted from the client. 
     */
    'payloadAuthor': string;
    'targetBranch': string;
    'newFeatureBranchName'?: string;
}
export interface SupportedProject {
    /**
     * Stable slug used by FE + URL paths (e.g. `zalaris-main`).
     */
    'id': string;
    'displayName': string;
}

/**
 * PrDispatchApi - axios parameter creator
 */
export const PrDispatchApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns the allow-listed projects that the signed-in user may dispatch to. Sourced from `pullguardian.prdispatch.projects`; adding a new project is a yml change. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSupportedProjects: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/prdispatch/projects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PrDispatchRequest} prDispatchRequest 
         * @param {string} [requestId] Optional client-supplied correlation ID. When present, it is placed into the logging MDC, echoed into downstream log lines, and propagated onto the Service Bus message as the &#x60;correlationId&#x60; JMS property and &#x60;JMSCorrelationID&#x60;. When omitted, the server generates a UUID. Use this header to correlate HTTP intake with downstream dispatch logs. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitPrDispatch: async (prDispatchRequest: PrDispatchRequest, requestId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'prDispatchRequest' is not null or undefined
            assertParamExists('submitPrDispatch', 'prDispatchRequest', prDispatchRequest)
            const localVarPath = `/api/prdispatch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (requestId != null) {
                localVarHeaderParameter['Request-Id'] = String(requestId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(prDispatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PrDispatchApi - functional programming interface
 */
export const PrDispatchApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PrDispatchApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns the allow-listed projects that the signed-in user may dispatch to. Sourced from `pullguardian.prdispatch.projects`; adding a new project is a yml change. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSupportedProjects(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SupportedProject>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSupportedProjects(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrDispatchApi.listSupportedProjects']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PrDispatchRequest} prDispatchRequest 
         * @param {string} [requestId] Optional client-supplied correlation ID. When present, it is placed into the logging MDC, echoed into downstream log lines, and propagated onto the Service Bus message as the &#x60;correlationId&#x60; JMS property and &#x60;JMSCorrelationID&#x60;. When omitted, the server generates a UUID. Use this header to correlate HTTP intake with downstream dispatch logs. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitPrDispatch(prDispatchRequest: PrDispatchRequest, requestId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitPrDispatch(prDispatchRequest, requestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PrDispatchApi.submitPrDispatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PrDispatchApi - factory interface
 */
export const PrDispatchApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PrDispatchApiFp(configuration)
    return {
        /**
         * Returns the allow-listed projects that the signed-in user may dispatch to. Sourced from `pullguardian.prdispatch.projects`; adding a new project is a yml change. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSupportedProjects(options?: RawAxiosRequestConfig): AxiosPromise<Array<SupportedProject>> {
            return localVarFp.listSupportedProjects(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PrDispatchRequest} prDispatchRequest 
         * @param {string} [requestId] Optional client-supplied correlation ID. When present, it is placed into the logging MDC, echoed into downstream log lines, and propagated onto the Service Bus message as the &#x60;correlationId&#x60; JMS property and &#x60;JMSCorrelationID&#x60;. When omitted, the server generates a UUID. Use this header to correlate HTTP intake with downstream dispatch logs. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitPrDispatch(prDispatchRequest: PrDispatchRequest, requestId?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.submitPrDispatch(prDispatchRequest, requestId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PrDispatchApi - object-oriented interface
 */
export class PrDispatchApi extends BaseAPI {
    /**
     * Returns the allow-listed projects that the signed-in user may dispatch to. Sourced from `pullguardian.prdispatch.projects`; adding a new project is a yml change. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listSupportedProjects(options?: RawAxiosRequestConfig) {
        return PrDispatchApiFp(this.configuration).listSupportedProjects(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PrDispatchRequest} prDispatchRequest 
     * @param {string} [requestId] Optional client-supplied correlation ID. When present, it is placed into the logging MDC, echoed into downstream log lines, and propagated onto the Service Bus message as the &#x60;correlationId&#x60; JMS property and &#x60;JMSCorrelationID&#x60;. When omitted, the server generates a UUID. Use this header to correlate HTTP intake with downstream dispatch logs. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public submitPrDispatch(prDispatchRequest: PrDispatchRequest, requestId?: string, options?: RawAxiosRequestConfig) {
        return PrDispatchApiFp(this.configuration).submitPrDispatch(prDispatchRequest, requestId, options).then((request) => request(this.axios, this.basePath));
    }
}



